﻿import {currentCulture, DateTime} from "@2d-front-monorepo/core";

export function formatDateTime(date: DateTime): string {
	return currentCulture().formatDateTime(date, "medium");
}
